import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { appInitializer } from './interceptors/app.initializer';
import { MyHttpInterceptor } from './interceptors/my.http.interceptor';

/** Components */
import { AppComponent } from './app.component';
import { DetailsComponent } from './routes/details/details.component';
import { HomeComponent } from './routes/home/home.component';
import { LegalPageComponent } from './routes/legalPages/legal-page/legal-page.component';
import { OnDemandComponent } from './routes/on-demand/on-demand.component';
import { OnDemandCatalogComponent } from './routes/on-demand-catalog/on-demand-catalog.component';
import { SearchComponent } from './routes/search/search.component';
import { SettingsComponent } from './routes/settings/settings.component';

/** Modules  */
import { AppRoutingModule } from './app-routing.module';
import { AccountModule } from './routes/account/account-module';
import { ComponentsModule } from './components/components-module';
import { DialogsModule } from './dialogs/dialogs-module';
import { ListsModule } from './routes/lists/lists-module';
import { ShareModule } from './share-module';
import { SubscriberModule } from './routes/subscriber/subscriber-module';

/** Providers Services  */
import { AdverticalService } from './services/adverticalService/advertical.service';
import { UserService } from './services/userService/user.service';

@NgModule({
  declarations: [
    AppComponent,
    DetailsComponent,
    HomeComponent,
    LegalPageComponent,
    OnDemandComponent,
    OnDemandCatalogComponent,
    SearchComponent,
    SettingsComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    AccountModule,
    ComponentsModule,
    DialogsModule,
    ListsModule,
    ShareModule,
    SubscriberModule
  ],
  providers: [{
    provide: APP_INITIALIZER,
    useFactory: appInitializer,
    multi: true,
    deps: [UserService, AdverticalService]
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: MyHttpInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }